import { Injectable } from '@angular/core';
import { PermissionType } from '@com-delta-idp/mnx-capability-profile-selector-ui';
import {
  DashboardResponse,
  loginAndGetDashboardResponse
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import {
  BUSINESS,
  BUSINESS_DESCRIPTION,
  DOMAIN_PROD_URL,
  PERM_TYPE
} from '../constants/profile-selector-constants';
import {
  CompanyDescription,
  ProfileSelector,
  ProfileSelectorAEM,
  URL
} from '../models/profile-selector-aem.interface';
import { ProfileSelectorAdapterHelperSupportService } from './profile-selector-adapter-helper-support.service';
@Injectable({
  providedIn: 'root'
})
export class ProfileSelectorAdapterHelperService extends ProfileSelectorAdapterHelperSupportService {
  deconstructResponse(
    response: Partial<DashboardResponse> | loginAndGetDashboardResponse,
    aemResponse: ProfileSelectorAEM
  ): void {
    this.setUserDetails(response);
    this.setCompanyDetails(response);
    this.setHeaderFooterDetails(aemResponse.profileSelector);
    this.setPageDetails(aemResponse.profileSelector);
  }

  setUserDetails(
    response: Partial<DashboardResponse> | loginAndGetDashboardResponse
  ): void {
    const { firstName, lastName, userId, permType, program, pgmType } =
      response;
    this.firstName = firstName;
    this.lastName = lastName;
    this.userId = userId?.split('|') ?? '';
    this.permType = permType?.split('|');
    this.program = program?.split('|') ?? '';
    this.pgmType = pgmType?.split('|') ?? '';
  }

  setCompanyDetails(
    response: Partial<DashboardResponse> | loginAndGetDashboardResponse
  ): void {
    const { crprtName, crprtAgrmntTypeCode, crprtAgrmntId } = response;
    this.companyName = crprtName?.split('|');
    this.crprtAgrmntTypeCode = crprtAgrmntTypeCode?.split('|') ?? '';
    this.crprtAgrmntId = crprtAgrmntId?.split('|') ?? '';
    this.setCorporateCode();
  }

  setHeaderFooterDetails(profileSelector: ProfileSelector): void {
    const {
      headerTitle,
      headerSubTitle,
      footerSubTitle,
      footerSubTitleWithoutTermsOfUse,
      businessTitle,
      personalTitle,
      permissionTypes
    } = profileSelector;
    this.headerTitle = headerTitle;
    this.headerSubTitle = headerSubTitle;
    this.footerSubTitle = footerSubTitle;
    this.footerSubTitleNoTerms = footerSubTitleWithoutTermsOfUse;
    this.businessTitle = businessTitle;
    this.personalTitle = personalTitle;
    this.permissionTypes = permissionTypes;
  }

  setPageDetails(profileSelector: ProfileSelector): void {
    const { companyDescription, title, url, pageHeader, nuTravelEAMFlag } =
      profileSelector;
    this.companyDescription = companyDescription;
    this.title = title;
    this.url = url;
    this.deltaLogoUrl = pageHeader.logoUrl;
    this.altText = pageHeader.altText;
    this.nuTravelEAMFlag = nuTravelEAMFlag ?? 'true';
  }

  transformPageHeader(): void {
    this.pageHeader = {
      headerTitle: `${this.headerTitle}, ${this.firstName}`,
      headerSubTitle: this.headerSubTitle,
      altText: this.altText,
      logoUrl: this.deltaLogoUrl
    };
    this.profileSelectorPageFooter = {
      footerSubText: this.footerSubTitle,
      footerSubTextWithoutToU: this.footerSubTitleNoTerms
    };
  }

  transformPersonalProfileView(): void {
    this.personalProfileView = {
      title: this.personalTitle,
      displayName: `${this.firstName} ${this.lastName}`,
      firstName: this.firstName ?? '',
      selectedState: true
    };
  }

  setDefaultBusiness(): PermissionType {
    const defaultBusiness = {
      title: this.title.permType_B ?? BUSINESS,
      description: this.companyDescription.permType_B ?? BUSINESS_DESCRIPTION,
      urlToRedirect: this.url.permType_B ?? DOMAIN_PROD_URL,
      selectedState: false,
      permType: PERM_TYPE.B
    };
    return defaultBusiness;
  }

  adminLink(business: string, businessAccountIndex: number): void {
    const targetVal = business ? '_self' : '_blank';
    const userIdList = this.dashboardResponse.userId
      ? this.dashboardResponse.userId.split('|')
      : '';
    const adminLinkUrl = this.profileSelectorUtilService.getAdminUrl(
      this.url.nuTravelAdminLoginUrl,
      userIdList[businessAccountIndex]
    );
    window.open(adminLinkUrl, targetVal);
  }

  permissionListAdminAndSkyBonusPath(type: string): PermissionType[] {
    const defaultBusiness = this.setDefaultBusiness();
    const permissionTypeArray: PermissionType[] = [defaultBusiness];
    const typeArray = type.split(',');
    typeArray.reverse();
    typeArray.forEach((type) => {
      const readingFromAem = type ? `permType_${type}` : '';
      permissionTypeArray.push({
        title: this.title[readingFromAem as keyof CompanyDescription],
        description:
          this.companyDescription[readingFromAem as keyof CompanyDescription],
        urlToRedirect: this.url[readingFromAem as keyof URL],
        selectedState: false,
        permType: type
      });
    });
    return permissionTypeArray;
  }
}
